<div class="login-page">
  <div class="lyt-login-container">
    <div class="overlay">
      <div class="login-panel">
        <div class="row no-gutters">
          <div class="col-md-3 col-12">
            <div class="left-side"></div>
          </div>
          <div class="col-md-6 col-12">
            <div class="right-side bg-white">
              <div class="login-block">
                <h3 class="head">Change Password</h3>
                <form class="login-form" [formGroup]="changePasswordForm" (ngSubmit)="changePswd()">
                  <div class="col-12">
                    <input
                      type="text"
                      placeholder="User ID"
                      formControlName="userID"
                      class="input-login"
                      required />
                  </div>
                  <div class="col-12">
                    <input
                      [type]="currpInputType"
                      placeholder="Current Password"
                      formControlName="currentPassword"
                      class="input-login"
                      required />
                    <input
                      type="checkbox"
                      (click)="
                        $event.target.checked
                          ? (this.currpInputType = 'text')
                          : (this.currpInputType = 'password')
                      "
                      class="form-check-input" />
                  </div>
                  <div class="col-12">
                    <input
                      [type]="newpInputType"
                      placeholder="New Password"
                      formControlName="newPassword"
                      class="input-login"
                      required />
                    <input
                      type="checkbox"
                      (click)="
                        $event.target.checked
                          ? (this.newpInputType = 'text')
                          : (this.newpInputType = 'password')
                      "
                      class="form-check-input" />

                    <div
                      class="text-danger"
                      *ngIf="
                        changePasswordForm.get('newPassword').invalid &&
                        (changePasswordForm.get('newPassword').touched ||
                          changePasswordForm.get('newPassword').dirty)
                      ">
                      <div *ngIf="changePasswordForm.get('newPassword').hasError('required')">
                        Password is required
                      </div>
                      <div
                        class="text-danger"
                        *ngIf="changePasswordForm.get('newPassword').hasError('required')">
                        Password must be at least 8 characters long.
                      </div>
                      <div
                        class="text-danger"
                        *ngIf="changePasswordForm.get('newPassword').hasError('passwordStrength')">
                        {{ changePasswordForm.get('password').errors['passwordStrength'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <input
                      [type]="cnpInputType"
                      formControlName="confirmPassword"
                      placeholder="Confirm Password"
                      class="input-login"
                      required />
                    <input
                      type="checkbox"
                      (click)="
                        $event.target.checked
                          ? (this.cnpInputType = 'text')
                          : (this.cnpInputType = 'password')
                      "
                      class="form-check-input" />
                  </div>
                  <p
                    class="text-danger"
                    *ngIf="
                      changePasswordForm.get('confirmPassword').hasError('required') &&
                      changePasswordForm.get('confirmPassword').touched
                    ">
                    Password is required
                  </p>
                  <p
                    class="text-danger"
                    *ngIf="
                      this.changePasswordForm.get('newPassword').value !==
                        this.changePasswordForm.get('confirmPassword').value &&
                      changePasswordForm.get('confirmPassword').dirty
                    ">
                    Password does not match
                  </p>
                  <button
                    type="submit"
                    class="btn btn-login"
                    [disabled]="changePasswordForm.invalid">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
